import styled from "styled-components";
import { Typography } from "antd";
import { FONT_SIZE_PX, FONT_WEIGHT } from "config/theme/constants";

export const BaseFormTitle = styled(Typography.Text)`
  font-weight: ${FONT_WEIGHT.semibold};
  font-size: ${FONT_SIZE_PX.xl};
  display: block;

`;
